import axios from './api-axios';
import { unsubscribe } from './ws-service';

export const lobbyTopic = (lobbyId: string): string => `/topic/public/lobby/${lobbyId}`;

/**
 * Leaves the lobby we are in and waits for the server to have seen it.
 *
 * The server binds a session to exactly one lobby, and it learns that a player
 * left only when their subscription to that lobby's topic ends — there is no
 * leave endpoint. Creating or joining a second lobby while the first is still
 * held binds the session to two, and from then on neither can be released:
 * both stay in "Available Lobbies" forever, listing players who are long gone.
 *
 * The UNSUBSCRIBE travels over the websocket while the join that follows goes
 * over HTTP, so nothing orders the two by itself. Hence the poll.
 */
export const leaveLobby = async (lobbyId?: string, username?: string): Promise<void> => {
  if (!lobbyId) return;

  unsubscribe(lobbyTopic(lobbyId));

  if (!username) return;
  for (let attempt = 0; attempt < 6; attempt++) {
    try {
      const res = await axios.get(`/rest/lobby/info/${lobbyId}`);
      if (!res.data?.participants?.includes(username)) return;
    } catch (error) {
      // The lobby is gone, which happens when we were the last one in it.
      return;
    }
    await new Promise(resolve => setTimeout(resolve, 250));
  }
};
